import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import { FiExternalLink } from "react-icons/fi";
import Header from "../component/header/Header";
import { withTranslation } from 'react-i18next';

const FACEBOOK_REELS_URL = 'https://www.facebook.com/farmchansawangyasothon/reels/';
const FACEBOOK_PAGE_URL = 'https://www.facebook.com/farmchansawangyasothon';
// Replace with your YouTube channel URL, e.g. https://www.youtube.com/@YourChannel
const YOUTUBE_CHANNEL_URL = 'https://www.youtube.com/@Chansawangfarm';

const GalleryImages = (t) => [
    <img key="1" src="/assets/images/portfolio/1.webp" alt={t('media.activityAlt')} />,
    <img key="2" src="/assets/images/portfolio/2.webp" alt={t('media.activityAlt')} />,
    <img key="3" src="/assets/images/portfolio/3.webp" alt={t('media.activityAlt')} />,
    <img key="4" src="/assets/images/portfolio/4.webp" alt={t('media.activityAlt')} />,
    <img key="5" src="/assets/images/portfolio/5.webp" alt={t('media.activityAlt')} />,
    <img key="6" src="/assets/images/portfolio/6.webp" alt={t('media.activityAlt')} />,
    <img key="7" src="/assets/images/portfolio/7.webp" alt={t('media.activityAlt')} />,
    <img key="8" src="/assets/images/portfolio/8.webp" alt={t('media.activityAlt')} />,
    <img key="9" src="/assets/images/portfolio/9.webp" alt={t('media.activityAlt')} />,
    <img key="10" src="/assets/images/portfolio/10.webp" alt={t('media.activityAlt')} />
];

class MediaGallery extends Component {
    render() {
        const { t } = this.props;
        return (
            <React.Fragment>
                <PageHelmet pageTitle={t('media.pageTitle')} siteName={t('common.siteName')} />
                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.webp" />

                <div className="portfolio-area ptb--60 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center mb--30">
                                    <h3 className="title">{t('media.title')}</h3>
                                </div>
                            </div>
                        </div>

                        {/* Facebook Reels section */}
                        <div className="row mb--50">
                            <div className="col-lg-12">
                                <div className="media-reels-block">
                                    <h4 className="media-reels-title">{t('media.reelsTitle')}</h4>
                                    <p className="media-reels-desc">{t('media.reelsDesc')}</p>
                                    <a
                                        href={FACEBOOK_REELS_URL}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-primary btn-lg media-reels-cta"
                                    >
                                        {t('media.reelsCta')}
                                        <FiExternalLink className="ml-2" style={{ verticalAlign: 'middle', marginLeft: '6px' }} />
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* YouTube section */}
                        <div className="row mb--50">
                            <div className="col-lg-12">
                                <div className="media-youtube-block">
                                    <h4 className="media-youtube-title">{t('media.youtubeTitle')}</h4>
                                    <p className="media-youtube-desc">{t('media.youtubeDesc')}</p>
                                    <a
                                        href={YOUTUBE_CHANNEL_URL}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-lg media-youtube-cta"
                                    >
                                        {t('media.youtubeCta')}
                                        <FiExternalLink style={{ verticalAlign: 'middle', marginLeft: '6px' }} />
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* Facebook Page embed */}
                        <div className="row mb--40">
                            <div className="col-lg-12 text-center">
                                <div className="media-facebook-embed">
                                    <iframe
                                        title={t('media.facebookPageTitle')}
                                        src={`https://www.facebook.com/plugins/page.php?href=${encodeURIComponent(FACEBOOK_PAGE_URL)}&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true`}
                                        width="340"
                                        height="500"
                                        style={{ border: 'none', overflow: 'hidden' }}
                                        scrolling="no"
                                        frameBorder="0"
                                        allowFullScreen
                                        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            {GalleryImages(t).map((image, index) => (
                                <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={index}>
                                    <div className="im_portfolio mb--30">
                                        <div className="thumbnail_inner">
                                            <div className="thumbnail">
                                                {image}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
            </React.Fragment>
        )
    }
}
export default withTranslation()(MediaGallery);
